// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__omq_a","approved":"Status_approved__q3por","rejected":"Status_rejected__23rXL","expired":"Status_expired__S1MXV","label":"Status_label__1H0qV"};